module.exports = __webpack_public_path__ + "img/login_bg.07977e1c.png";